export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7283.03624f57.jpg";